<template>
  <div class="page-container">
    <van-nav-bar fixed :title="title" :z-index="10">
      <template #right>
        <img
          style="width: 30px"
          src="../../assets/img/memberIntegral/mi_home.png"
          alt=""
          @click="onRight" />
      </template>
    </van-nav-bar>
    <!-- 轮播图 -->
    <van-swipe class="home-swipe" :autoplay="10000" v-if="banners.length > 0">
      <van-swipe-item v-for="(item, index) in banners" :key="index">
        <van-image
          class="banner-image"
          @click="pointClick(item)"
          :src="item.url"
          fit="fill" />
      </van-swipe-item>
    </van-swipe>
    <div class="list-contain-mall" v-if="categorys.length > 0">
      <van-tabs
        v-model="categoryId"
        animated
        swipeable
        offset-top="46"
        sticky
        title-active-color="rgb(51, 51, 51)"
        title-inactive-color="rgb(151, 151, 151)"
        @change="handleTabChange"
        @click="handleTabChange"
        :border="false">
        <van-tab
          v-for="item in categorys"
          :key="item.id"
          :title="item.name"
          :name="item.id">
          <div class="container">
            <integral-mall-list :mallList="item.goods" :categoryId="item.id" />
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <van-empty description="暂无数据" v-if="categorys.length == 0" />
  </div>
</template>
<script>
import { Empty, Image, Swipe, SwipeItem, Tab, Tabs } from "vant"
import IntegralMallList from "../memberIntegral/order/components/integralMallList.vue"
import { getGoodsTemplate } from "../../api/goods"
export default {
  name: "mall-template",
  components: {
    IntegralMallList,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Image.name]: Image,
    [Empty.name]: Empty
  },
  data() {
    return {
      title: "",
      banners: [],
      categorys: [],
      categoryId: "",
      templateId: ""
    }
  },
  mounted() {
    this.categoryId = this.$route.query.categoryId || ""
    this.templateId = this.$route.query.templateId || ""
    getGoodsTemplate(this.templateId)
      .then((data) => {
        this.title = data.name
        this.banners = data.banners
        this.categorys = data.menus
      })
      .catch((e) => {
        console.log("error msg == %O", e.msg)
      })
  },
  methods: {
    onRight() {
      sessionStorage.setItem("memberMallActive", 0)
      this.$router.push({ name: "integralMall" })
    },
    pointClick(item) {
      if (item.targetUrl && item.targetUrl.length > 0) {
        location.href = item.targetUrl
      }
    },
    handleTabChange(categoryId) {
      this.categoryId = categoryId
    }
  }
}
</script>
<style lang="less" scoped>
//轮播图
.home-swipe {
  height: 150px;
  .banner-image {
    width: 100%;
    height: 100%;
  }
}
.list-contain-mall {
  overflow: hidden;
  .container {
    overflow: hidden;
    height: 100%;
  }
}
</style>
